<template>
  <nav>
    <div class="relative">
      <button class="close" @click="closeNav">
        <i class="fas fa-times fa-2x"></i>
      </button>
      <button class="logout" @click="logout" v-if="isUser !== ''">
        <i class="fas fa-sign-out-alt fa-2x"></i>
      </button>
      <ul v-if="isUser">
        <li>
          <router-link to="/">{{ appVocubulary.home }}</router-link>
        </li>
        <li>
          <router-link to="/posts">{{ appVocubulary.posts }}</router-link>
        </li>
        <li>
          <router-link to="/about">{{ appVocubulary.about }}</router-link>
        </li>
        <li>
          <router-link to="/settings">{{ appVocubulary.settings }}</router-link>
        </li>
      </ul>
      <router-link to="/login" v-else>
        <i class="fas fa-door-open fa-5x"></i>
        <span> {{ appVocubulary.login }} </span>
      </router-link>
      <div class="settings">
        <div class="themes">
          <button @click="changeTheme">
            <i class="fas fa-circle switch"></i>
            <i class="fas fa-moon" v-if="theme === 'dark'"></i>
            <i class="fas fa-sun" v-else></i>
          </button>
        </div>
        <button @click="changeLang('ar')" class="lang">Ar</button> |
        <button @click="changeLang('en')" class="lang">En</button>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "WNav",
  data() {
    return {
      version: this.$store.state.Neptone_version,
      theme: localStorage.getItem("theme") || "light",
    };
  },
  computed: {
    isUser() {
      return this.$store.state.user.name;
    },
    lang() {
      return this.$store.state.lang;
    },
    appVocubulary() {
      return this.$store.state.appVocubulary[this.lang].components.nav;
    },
  },
  methods: {
    closeNav() {
      this.$store.commit("toggleNav", false);
    },
    logout() {
      sessionStorage.removeItem("thisNeptoneUser");
      this.$store.commit("resetUser");
      document.getElementById("login-link").click();
    },
    changeLang(lang) {
      document.querySelector("html").lang = lang;
      this.$store.commit("changeLang", lang);
      localStorage.setItem("language", lang);
    },
    changeTheme() {
      document.body.classList.toggle("dark-mode");

      if (
        !localStorage.getItem("theme") ||
        localStorage.getItem("theme") === "light"
      ) {
        localStorage.setItem("theme", "dark");
        this.theme = "dark";
      } else {
        localStorage.setItem("theme", "light");
        this.theme = "light";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
nav {
  direction: ltr;
  text-align: center;
  z-index: 10;
  background: var(--bg2);
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: 100vw;
  max-width: 300px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  box-shadow: -1px 0 8px -2px var(--shadow);

  .relative {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    align-content: center;
    height: 100%;
    width: 100%;

    .close,
    .logout {
      position: absolute;
      top: 30px;
      right: 20px;
      color: var(--text);
    }

    .logout {
      left: 20px;
    }

    .fa-door-open {
      display: block;
      margin-bottom: 20px;
      color: var(--text);
      & + span {
        color: var(--text);
        font-weight: bold;
      }
    }

    ul {
      width: 100%;
      padding: 0;
      list-style: none;
      align-self: center;

      li {
        margin: 30px 0;
        font-size: 1.1em;

        a {
          color: var(--text);
          font-weight: bold;
          text-decoration: none;

          &.router-link-exact-active {
            background-color: var(--accent);
            width: fit-content;
            margin: 0 auto;
            padding: 10px 20px;
            border-radius: 40px;
            color: white;
          }
        }
      }
    }
    .settings {
      width: 100%;
      position: absolute;
      bottom: 20px;
      .lang {
        margin: 20px 10px 0;
        color: var(--text);
      }

      .themes {
        button {
          position: relative;
          width: 48px;
          height: 24px;
          margin: 0 10px;
          border-radius: 40px;
          background: var(--accent);
          margin: 0 auto;
          i {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            color: white;
            &:not(.switch) {
              right: 6px;
            }
            &.switch {
              color: var(--bg);
              left: 6px;
            }
          }
        }
      }
      .langs {
        margin: 20px auto 10px;
      }
    }
  }
}
</style>
